import { getFunctions, httpsCallable } from 'firebase/functions';
import app from '../firebase/firebase-app';
import {
  applyLifecycleFieldsToUser,
  mapLifecycleError,
} from '../platform/accountLifecycle';

const functions = getFunctions(app);

function createCallable(name) {
  return httpsCallable(functions, name);
}

const deactivateAccountFn = createCallable('deactivateAccount');
const reactivateAccountFn = createCallable('reactivateAccount');
const requestAccountDeletionFn = createCallable('requestAccountDeletion');
const cancelAccountDeletionFn = createCallable('cancelAccountDeletion');

async function invokeLifecycle(callable, currentUser) {
  try {
    const result = await callable();
    return applyLifecycleFieldsToUser(currentUser, result.data || {});
  } catch (error) {
    throw new Error(mapLifecycleError(error));
  }
}

export async function deactivateAccount(currentUser) {
  return invokeLifecycle(deactivateAccountFn, currentUser);
}

export async function reactivateAccount(currentUser) {
  return invokeLifecycle(reactivateAccountFn, currentUser);
}

export async function requestAccountDeletion(currentUser) {
  return invokeLifecycle(requestAccountDeletionFn, currentUser);
}

export async function cancelAccountDeletion(currentUser) {
  return invokeLifecycle(cancelAccountDeletionFn, currentUser);
}
